import {
  createStore as reduxCreateStore,
  combineReducers,
  applyMiddleware,
} from "redux";
import createSagaMiddleware from "redux-saga";
import dataStore from "./dataStore";
import { carrierSagas } from "./sagas";
import { fromJS } from "immutable";

const REDUCER_SESSION_STATE = "REDUCER_SESSION_STATE";

const sessionMiddleware = (store) => (next) => (action) => {
  let result = next(action);

  sessionStorage.setItem(
    REDUCER_SESSION_STATE,
    JSON.stringify(store.getState())
  );
  return result;
};

let initialState = {};
let savedState = JSON.parse(sessionStorage.getItem(REDUCER_SESSION_STATE));
if (savedState) {
  for (let prop in savedState) {
    initialState[prop] = fromJS(savedState[prop]);
  }
}

const appReducer = combineReducers({
  dataStore,
});

const sagaMiddleware = createSagaMiddleware();

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

const createStore = () => {
  const store = reduxCreateStore(
    rootReducer,
    initialState,
    applyMiddleware(sagaMiddleware, sessionMiddleware)
  );

  sagaMiddleware.run(carrierSagas);

  return store;
};

export default createStore;
